//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import date from '@/config/dateCalculate.js'
import Model from '@/models/mobile'
import PayCommon from './PayCommon'
import { Decimal } from 'decimal.js'
export default {
  components: {
      PayCommon
  },
  data() {
    return {
      num: 1,
      inputName: '', //姓名
      inputPhone: '', //电话
      carTypeNmae:'',//车辆类型
      cycleUnit: '', //周期单位1：周 2：月 3：年，4：天
      endTime:'',//到期时间
      amount:'',//充值金额
      queryParams:this.$route.query
    };
  },
  created() {

    if(this.$isWx) {
      let listData = 	JSON.parse(sessionStorage.getItem('scanCodeataList'))
      this.queryParams =  listData;
    }

     if (this.queryParams.carType == 2) {
       this.carTypeNmae = '月卡车';
     } else if (this.queryParams.carType == 3) {
       this.carTypeNmae = '免费车';
     } else if (this.queryParams.carType == 14) {
       this.carTypeNmae = '贵宾车';
     } else if (this.queryParams.carType == 15) {
       this.carTypeNmae = '贵宾车1';
     } else if (this.queryParams.carType == 16) {
       this.carTypeNmae = '贵宾车2';
     } else if (this.queryParams.carType == 17) {
       this.carTypeNmae = '贵宾车3';
     }
     if (this.queryParams.zhouqiDanwei == 1) {
       this.cycleUnit = '周';
     } else if (this.queryParams.zhouqiDanwei == 2) {
       this.cycleUnit = '月';
     } else if (this.queryParams.zhouqiDanwei == 3) {
       this.cycleUnit = '年';
     } else if (this.queryParams.zhouqiDanwei == 4) {
       this.cycleUnit = '天';
     }

  this.endTime = date.GetDateDiff(this.queryParams.cardEndTime,this.num,this.queryParams.zhouqiDanwei);
  this.amount = new Decimal(this.queryParams.chargeMoney).mul(new Decimal(this.num)).toString()
   },
  methods: {
    handleChange(value) {
      this.endTime = date.GetDateDiff(this.queryParams.cardEndTime,value,this.queryParams.zhouqiDanwei);
      // this.amount = this.queryParams.chargeMoney * value;
      this.amount = new Decimal(this.queryParams.chargeMoney).mul(new Decimal(value)).toString()
    },
    pay() {

     this.openCard();
    },

    async  openCard (){
            const {
              unique
            } = this.queryParams;

            let {data} = await Model.createOrder({
              unique,
              ownerName: this.inputName,
              ownerTel: this.inputPhone,
              recharegeMoney: this.amount,
              cardEndTime: this.endTime,
              recharegeNum:this.num
            });

               if(!data.success) {

             return   this.$layer.msg(data.error)
              }

             let params = {
                 orderNo:data.list,
                 OrderAmount:this.amount,
                 gsBh:this.queryParams.gsbh,
                 xmBh:this.queryParams.xmbh,
                 parkNo: this.queryParams.parkNo,
                 tollPayRsq: ''
             }
          if(this.$isWx) {
              	params.pageType = 'renewalDetails';
              	params.pageUrl = location.href;
              	sessionStorage.setItem('wxPayParams',JSON.stringify(params));
              	var url = 'http://dzbus.iot.xin/mobile/confirmPay/666?params='+JSON.stringify(params);
              	if(location.assign){
              		location.assign(url)
              	}else{
              		window.open(url)
              	}
              	return
          this.$refs.payCommon.payByWx({
                                  params,
                                  fail: (res) => {
                                      this.$layer.msg(res.error)
                                  },
                                  paySuccess: (res) => {
                                    this.$layer.msg('支付成功！支付后30分钟短信通知充值结果，请注意查收！也可以输入车牌查看是否续费成功')
                                    this.$router.go(-1)
                                  },
                                  payFail: (res) => {
                                       this.$layer.msg('支付失败')
                                  }
                              })

          }else if(this.$isZfb){

           console.log('进来了',params);

          this.$refs.payCommon.payByZfb({
              params,
              success: (res) => {
                  Model.testCallback();
              },
              fail: (res) => {
                  this.$layer.msg(res.error);
              }
          })

          }


      },

    buttonClcik() {
      this.$router.push(`/mobile/renewalHistory/${this.queryParams.parkNo}/${this.queryParams.carNo}`);
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/renewalDetails.vue